import CourseTabsView from '@src/components/course/view/CourseTabsView';
import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

const CourseListPage = (props: WithRouterProps) => <CourseTabsView openedTab={props.params.openedTab}/>;

export default withRouter(CourseListPage);
